import { Platform } from 'react-native';
import { create } from 'zustand';
import {
    PathCategories,
    PathGpsCoordinates,
    Paths,
    PoiCategories,
    Pois,
    Aois,
    AoiCategories,
    AoiGpsCoordinates,
    SnowmobilePaths,
    SnowmobileSubPaths,
    LocalizedToken,
} from '@sodraberget/shared';
import { AppContent } from '../interfaces';

interface Data {
    // Path data
    paths?: Paths;
    pathGpsCoordinates?: PathGpsCoordinates;
    pathCategories?: PathCategories;

    // PoI data
    pois?: Pois;
    poiCategories?: PoiCategories;

    // AoI data
    aois?: Aois;
    aoiCategories?: AoiCategories;
    aoiGpsCoordinates?: AoiGpsCoordinates;

    // Snowmobile path data
    snowmobilePaths?: SnowmobilePaths;
    snowmobileSubPaths?: SnowmobileSubPaths;

    // Area data
    areas?: {[key: string]: LocalizedToken};

    // Content filters
    mainContent: AppContent;
    additionalMapContent?: AppContent;

    //Languages
    languages?: string[];

};

/**
 * Hook for accessing the path and poi data store
 */
const useDataStore = create<Data>((set) => {
    let mainContent: AppContent = {};
    let additionalMapContent: AppContent = {};

    switch (Platform.OS) {
        case 'web':
            //@ts-ignore
            const url = new URL(window.location.href);

            const mainContentString = url.searchParams.get('mainContent');
            mainContent = JSON.parse(mainContentString ?? '{}');

            const additionalMapContentString = url.searchParams.get('additionalMapContent');
            additionalMapContent = JSON.parse(additionalMapContentString ?? '{}');

            // Coerce category IDs to strings (URL may pass numbers)
            const toStringArray = (arr?: any[]) => arr?.map(v => String(v));
            mainContent.pathCategories = toStringArray(mainContent.pathCategories);
            mainContent.poiCategories = toStringArray(mainContent.poiCategories);
            mainContent.aoiCategories = toStringArray(mainContent.aoiCategories);
            mainContent.areas = toStringArray(mainContent.areas);

            // When only areas filter is specified (no category filters), default all
            // category arrays to [] so all types are shown (filtered by area).
            if (mainContent.areas?.length
                && !mainContent.pathCategories && !mainContent.poiCategories && !mainContent.aoiCategories) {
                mainContent.pathCategories = [];
                mainContent.poiCategories = [];
                mainContent.aoiCategories = [];
            }

            additionalMapContent.pathCategories = toStringArray(additionalMapContent.pathCategories);
            additionalMapContent.poiCategories = toStringArray(additionalMapContent.poiCategories);
            additionalMapContent.aoiCategories = toStringArray(additionalMapContent.aoiCategories);
            additionalMapContent.areas = toStringArray(additionalMapContent.areas);
            break;

        default:
            break;
    }

    return {
        mainContent,
        additionalMapContent,
    };
});

export { Data, useDataStore };